import React, { useState, useEffect } from 'react';
import { Outlet, Navigate, useNavigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import { AdminShell } from '../../components/admin/AdminShell';
import { AdminProvider } from '../../components/admin/AdminContext';
import { apiFetch } from '../lib/api-fetch';

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, isLoaded } = useUser();
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

  useEffect(() => {
    async function checkAdmin() {
      if (!isLoaded) return;
      if (!user) {
        setIsAdmin(false);
        return;
      }
      try {
        const res = await apiFetch('/api/v1/users/me');
        if (res.ok) {
          const data = await res.json();
          setIsAdmin(!!data.is_team_admin);
        } else {
          setIsAdmin(false);
        }
      } catch (err) {
        setIsAdmin(false);
      }
    }
    checkAdmin();
  }, [user, isLoaded]);

  if (!isLoaded || isAdmin === null) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-indigo-500/30 border-t-indigo-500 rounded-full animate-spin" />
      </div>
    );
  }

  if (isAdmin === false) {
    return <Navigate to="/courses" replace />;
  }

  const userPayload = user
    ? {
        fullName: user.fullName || user.firstName || 'Admin',
        primaryEmailAddress: user.primaryEmailAddress ? { emailAddress: user.primaryEmailAddress.emailAddress } : null,
        imageUrl: user.imageUrl || '',
      }
    : null;

  return (
    <AdminProvider>
      <AdminShell
        user={userPayload}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      >
        <Outlet />
      </AdminShell>
    </AdminProvider>
  );
}
